import { useState, useEffect } from 'react';
import CompanyModel from './CompaniesModel';
import { useSelector, useDispatch } from 'react-redux';
import { selectAllCompaniesStatus } from '../store/company.selectors';
import { fetchAllCompanies, resetCompany } from '../store/company.actions';
import { Box } from '@mui/material';
import { ContentContainer } from '../../../utils/common/styles/commonStyles';
import AddCompanyModal from './AddCompany';
import SearchHeader from '../components/SearchHeader';

const Company = () => {
  const dispatch = useDispatch();
  const status = useSelector(selectAllCompaniesStatus);

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [modalMode, setModalMode] = useState('add');
  const [searchTerm, setSearchTerm] = useState('');

  const handleOpenModal = (mode = 'add') => {
    setModalMode(mode);
    setIsModalOpen(true);
  };

  const handleCloseModal = (event, reason) => {
    if (reason === 'backdropClick' || reason === 'escapeKeyDown') return;
    dispatch(resetCompany());
    setIsModalOpen(false);
  };

  useEffect(() => {
    if (status === 'idle') {
      dispatch(fetchAllCompanies());
    }
  }, [status]);

  useEffect(() => {
    dispatch(resetCompany());
  }, []);

  return (
    <ContentContainer>
      {/* PASS STATE + SETTER */}
      <SearchHeader
        searchTerm={searchTerm}
        setSearchTerm={setSearchTerm}
        handleOpenModal={handleOpenModal}
      />

      <Box sx={{ animation: 'fadeIn 0.5s ease-in' }}>
        <CompanyModel handleOpenModal={handleOpenModal} searchTerm={searchTerm} />
      </Box>

      <AddCompanyModal open={isModalOpen} handleClose={handleCloseModal} mode={modalMode} />
    </ContentContainer>
  );
};

export default Company;
